import {
  CREATE_CREDIT_REQUEST,
  CREATE_CREDIT_REQUEST_SUCCESS,
  CREATE_CREDIT_REQUEST_FAILURE,
  CREATE_CREDIT_REQUEST_RESET,
} from '../constants';

interface StateType {
  loading: boolean;
  success: boolean;
  error: any;
}

interface ActionType {
  type: string;
  payload?: any;
}

const initialState: StateType = {
  loading: false,
  success: false,
  error: null,
};

export const createCreditRequestReducer = (state = initialState, action: ActionType): StateType => {
  switch (action.type) {
    case CREATE_CREDIT_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case CREATE_CREDIT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case CREATE_CREDIT_REQUEST_RESET:
      return {
        ...state,
        loading: false,
        success: false,
      };

    case CREATE_CREDIT_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
